import React, { Children } from 'react';
import PropTypes from 'prop-types';
import { safeRest } from '@wds/utils';
import { useTheme } from 'react-jss';

import GridItem from './GridItem';

import useStylesGrid from './useStylesGrid';

const Grid = ({ children, noGutters, noBleeds, fluid, ...rest }) => {
  const theme = useTheme();
  const { wrenchGrid, wrenchGridContainer } = useStylesGrid({
    noGutters,
    noBleeds,
    fluid,
    theme,
  });

  const gridItems = Children.map(children, (child) => {
    return React.cloneElement(child, {
      noGutters,
    });
  });

  return (
    <>
      <div className={wrenchGridContainer} {...safeRest(rest)}>
        <div className={wrenchGrid}>{gridItems}</div>
      </div>
    </>
  );
};

Grid.propTypes = {
  /**
   * Should be Grid.Item Component
   */
  children: PropTypes.node.isRequired,
  /**
   * Removes maxwidth from grid container.
   */
  fluid: PropTypes.bool,
  /**
   * Enable gaps on the left anf right of the grid.
   */
  noBleeds: PropTypes.bool,
  /**
   * Enable gutters between child elements in the grid.
   */
  noGutters: PropTypes.bool,
};

Grid.defaultProps = {
  fluid: false,
  noBleeds: false,
  noGutters: false,
};

Grid.Item = GridItem;

export default Grid;
